<template>
    <el-dialog
        :before-close="cancel"
        :close-on-press-escape="false"
        :title="`员工信息导入`"
        :visible.sync="dialogVisible"
        center
        width="500px">
        <div class="flex flex-direction">
            <div class="info-container">
                <div class="title">1.下载导入模版 <span class="tips">根据提示信息，填写员工信息。</span></div>
                <el-link :href="`${FILE_PATH_FW}/excelupload/temp_demo.xls?mid=${emofUserTokenSafer}`" target="_blank" :underline="false"
                         class="self-start margin-top-sm">
                    <el-button class="submit"><i class="el-icon-download"></i>下载空的模版表格</el-button>
                </el-link>
            </div>
            <div class="info-container margin-tb-sm">
                <div class="title margin-bottom-sm">2.上传完善后的表格</div>
                <el-upload
                    :action="BASE_URL_FW + '/Home/Team/importEmployee'"
                    :data="fileData"
                    name="file"
                    :on-success="handleAvatarSuccess"
                    :show-file-list="false"
                    accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
                    <el-button class="submit"><i class="el-icon-upload2"></i>点击上传
                    </el-button>
                </el-upload>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import {BASE_URL_FW, FILE_PATH_FW} from "@/config";
import {confirm, TOAST, toast} from "@/utils/utils";

export default {
    name: "ImportUserInfo",
    data() {
        return {
            FILE_PATH_FW: FILE_PATH_FW,
            BASE_URL_FW: BASE_URL_FW
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        emofUserTokenSafer() {
            return this.$store.state.emofUserTokenSafer;
        },
        fileData() {
            return {
                mid: this.emofUserTokenSafer,
            }
        }
    },
    created() {

    },
    methods: {
        cancel() {
            this.$emit('watchInfoState', false)
        },
        //  上传成功
        handleAvatarSuccess(file) {
            if (file.status === 200) {
                confirm('提示',file.msg)
                this.$emit('watchInfoState', true)
            } else {
                confirm('提示',file.msg)
            }
        },
        //  上传失败
        uploadError() {
            toast('上传出错，请重试！',TOAST.error)
        },
    },
    filters: {

    },
    watch: {}
}
</script>

<style lang="scss" scoped>

.info-container {
    height: 130px;
    background-color: #f4f4f4;
    border-radius: 10px;
    padding: 25px;
    .title {
        font-size: 16px;
        color: #333333;
    }

    .tips {
        font-size: 12px;
        color: #666666;
    }

    .submit{
        width: 200px;
        height: 42px;
        background: #0a2240;
        color: #FFFFFF;
    }
}

</style>